import { loadData, removeElement } from './helpers';

class CancelUpdate {
  constructor() {
    this.Btn = document.querySelector('.js-cancel-update');
    if (this.Btn) {
      this.Btn.addEventListener('click', event => {
        event.preventDefault();
        loadData(this.Btn.getAttribute('data-url'))
          .then(json => {
            if (!json.error) {
              window.location.reload(true);
            }
          })
          .catch(error => console.error(error.message));
      });
    }
  }
}

export default new CancelUpdate();



// WEBPACK FOOTER //
// ./src/js/cancel-update.js